import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import TextInput from '../../../../../common/components/TextInput';
import RssFeedCRUDActions from "@mm/state/actions/RssFeedCRUDActions";
import { DEFAULT_FEED_NAME } from '../../constants/texts';
import './RssFeedDetails.scss';

const NameTextInput = ({ name, onNameChange, updateFeed }) =>
  <div className="feed-details__input-container">
    <div className="feed-details__ad-name-container">
      <div className="feed-details__field-title">Name</div>
      <TextInput
        placeholder="Feed name"
        className="feed-details__feed-name"
        maxLength="50"
        onChange={onNameChange}
        onBlur={updateFeed}
        onMouseLeave={updateFeed}
        value={name}
      />
    </div>
  </div>

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateFeed: () => {
    const { feed, chatbotId } = ownProps;
    const name = ownProps.name && ownProps.name.trim();
    if (feed.name !== name) {
      const nextName = name || DEFAULT_FEED_NAME;
      const newFeed = Object.assign({}, feed, { name: nextName });
      ownProps.setName(nextName);
      return dispatch(RssFeedCRUDActions.update(chatbotId, newFeed));
    }
    return null;
  },
})

const enhance = compose(
  withState('name', 'setName', ({ feed: { name } }) => name),
  withHandlers({ onNameChange: ({ setName }) => e => setName(e.target.value) }),
  connect(null, mapDispatchToProps),
);

export default enhance(NameTextInput);
